export const modalContainer = (darkMode:boolean) => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // padding:"20px",
    zIndex: 1300,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: darkMode ? '#3A3A3A' : '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      background: darkMode ? '#555' : '#888',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: darkMode ? '#777' : '#555',
    },
  };
};

export const modalStyles =(darkMode:boolean)=> {
  return {
    position: "absolute",
    top:"20px",
    width: "900px",
    maxWidth: '90vw',
    bgcolor: darkMode ? "#2D2D2D" : "#FFFFFF",
    boxShadow: 24,
    border: darkMode ? "1px solid #444" : "none",
    display: "flex",
    flexDirection: "column",
    outline: 'none',
  }
};

export const modalContent =(darkMode:boolean)=> {
  return {
    p: 3,
    paddingBottom:"0px",
    bgcolor: darkMode ? "#2D2D2D" : "#FFFFFF",
    flex: 1,
    // overflow: "auto"
  }
}

export const modalHeader =(darkMode:boolean)=> {
  return {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // p: 3,
    borderBottom: darkMode ? "1px solid #444" : "1px solid #E0E0E0",
    backgroundColor: "#F6F7F2",
    gap: "10px",
    angle: "0 deg",
    opacity: 1,
    padding: "15px",
  }
}

export const modalInfo = (darkMode: boolean) => {
  return {
    border:"1px solid #FEC84B",
    padding:"8px",
    minHeight:"38px",
    gap:"8px",
    // borderRadius: "0px",
    bgcolor: darkMode ? "#3A3A3A" : "#FFF8E1"
  };
};

export const attachmentLabelStyle = {
  display: "flex",
  alignItems: "center",
};

export const attachmentTooltipTriggerStyle = {
  display: "inline-flex",
  cursor: "pointer",
};